import React from 'react'
import { Card, Row, Col, Spinner, Badge } from 'react-bootstrap'
import { BlockchainOverview } from '../types'
import * as S from '../styles'

interface BlockchainOverviewCardProps {
  data?: BlockchainOverview
  loading: boolean
}

export const BlockchainOverviewCard: React.FC<BlockchainOverviewCardProps> = ({
  data,
  loading
}) => {
  const formatNumber = (value: number) => {
    return new Intl.NumberFormat('pt-BR').format(value)
  }

  const formatGas = (value: number) => {
    if (value >= 1000000) {
      return `${(value / 1000000).toFixed(1)}M`
    }
    if (value >= 1000) {
      return `${(value / 1000).toFixed(1)}K`
    }
    return value.toString()
  }

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text)
    // Could add a toast notification here
  }

  if (loading || !data) {
    return (
      <Card className="h-100">
        <Card.Header>
          <Card.Title as="h5">
            <i className="feather icon-link text-primary mr-2" />
            Visão Geral Blockchain
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <S.LoadingSpinner>
            <Spinner animation="border" />
          </S.LoadingSpinner>
        </Card.Body>
      </Card>
    )
  }

  return (
    <Card className="h-100">
      <Card.Header>
        <Card.Title as="h5" className="d-flex align-items-center">
          <i className="feather icon-link text-primary mr-2" />
          Visão Geral Blockchain
          <Badge
            variant={data.networkStatus === 'healthy' ? 'success' : 'warning'}
            className="ml-auto"
          >
            {data.networkStatus === 'healthy' ? 'Saudável' : 'Degradado'}
          </Badge>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Row className="mb-4">
          <Col sm={6}>
            <div className="text-center">
              <h3 className="text-primary mb-1">
                {formatNumber(data.totalTransactions)}
              </h3>
              <p className="text-muted mb-0">Total de Transações</p>
            </div>
          </Col>
          <Col sm={6}>
            <div className="text-center">
              <h3 className="text-success mb-1">
                {formatGas(data.totalGasConsumed)}
              </h3>
              <p className="text-muted mb-0">Gas Consumido</p>
            </div>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col sm={12}>
            <div className="text-center">
              <h3 className="text-info mb-1">{data.smartContractsDeployed}</h3>
              <p className="text-muted mb-0">Smart Contracts Implantados</p>
            </div>
          </Col>
        </Row>

        <div>
          <h6 className="mb-3">Transações Recentes:</h6>
          {data.recentTransactionHashes.map((hash, index) => (
            <div key={index} className="mb-2">
              <S.TransactionHash
                onClick={() => copyToClipboard(hash)}
                title="Clique para copiar"
              >
                {hash.substring(0, 12)}...{hash.substring(hash.length - 8)}
              </S.TransactionHash>
            </div>
          ))}
        </div>

        <div className="mt-4 pt-3 border-top">
          <small className="text-muted">
            <i className="feather icon-info mr-1" />
            Todas as transações são verificáveis na rede Hyperledger Besu
          </small>
        </div>
      </Card.Body>
    </Card>
  )
}
